import SupervisorContextForm from "./SupervisorContextForm";
import Spinner from "../../../../SimpleComponents/Spinner/Spinner";
import type {
  PnlUnknownLoss,
  TimeRangeFinite,
} from "../../../../../types/types";
import ErrorBoundary from "../../../../SimpleComponents/Errors/ErrorBoundary";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { CUSTOMERS_WHO_USE_SUPERVISOR_CONTEXT_TAGGING } from "constants/customers";
import { useHubletTagsQuery } from "components/Dashboard/Timeline/RetrotagPopper/retrotagQueryHooks";

type SupervisorContextProps = {
  pnlPopupTimeRange: TimeRangeFinite;
  date: string;
  startTime: string;
  endTime: string;
  unknownPnlLoss: PnlUnknownLoss;
  processId: string;
};

export default function SupervisorContext({
  pnlPopupTimeRange,
  date,
  startTime,
  endTime,
  unknownPnlLoss,
  processId,
}: SupervisorContextProps) {
  const ckey = useCustomerKey();

  const scriptUrl = CUSTOMERS_WHO_USE_SUPERVISOR_CONTEXT_TAGGING[
    ckey
  ]?.processConfig.filter(
    processConfig => processConfig.processId === processId
  )[0]?.scriptUrl;

  const { allocatableTimeMs } = unknownPnlLoss;

  const [hubletTags] = useHubletTagsQuery({ machemetryId: processId });

  // Wait for fetching of tags from API to complete
  return !hubletTags ? (
    <Spinner />
  ) : (
    <ErrorBoundary id="SupervisorContext">
      <SupervisorContextForm
        hubletTags={hubletTags}
        date={date}
        startTime={startTime}
        endTime={endTime}
        unknownTime={allocatableTimeMs}
        timeRange={pnlPopupTimeRange}
        processId={processId}
        scriptUrl={scriptUrl}
      />
    </ErrorBoundary>
  );
}
